import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useGoBack } from "@/common/hooks/useGoBack";
import { FormTransformers } from "@/common/utils/formTransformers";
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import { useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

interface ManualEntryProposalsClientRejectProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
}

const ManualEntryProposalsClientReject = ({
  proposal
}: ManualEntryProposalsClientRejectProps) => {
  const { companyId, id } = useParams();

  const goBack = useGoBack();

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: clientReject,
    isPending: clientRejectIsPending,
  } = useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject({
    proposalId: proposal.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardings', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardingsDirectiveEntryKlasses', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] });

        goBack({
          fallback: `/companies/${companyId}/maintenance/workflows/${id}`,
          searchLastRouteFromFallback: true,
        });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="yellow"
            operationKlassToCheckPermission="Admin::Maintenance::EstablishmentChoice::ManualEntryProposals::ClientReject"
          >
            Declinar
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={() => clientReject()}
        confirmButtonIsLoading={clientRejectIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default ManualEntryProposalsClientReject;
